import React from 'react';
import PropTypes from 'prop-types';
import { IntegrationsForm } from 'components/organisms/IntegrationsForm';

export const Integrations = ({ handleNextStep, activeNetwork, handleGoogleSyncComplete }) => (
  <IntegrationsForm
    network={activeNetwork}
    title="Sync your contacts"
    description="Install our Chrome extension, automatically sync your connections, and unleash unlimited warm introductions."
    onContinue={() => handleNextStep('integrations')}
    onSkip={() => handleNextStep('integrations')}
    linkedinSyncBasePath={`/onboarding/${activeNetwork?.slug}/linkedin`}
    linkedinSyncReturnTo="onboarding-integrations"
    containerStyle={{ mt: '100px' }}
    onGoogleSyncComplete={handleGoogleSyncComplete}
  />
);

Integrations.propTypes = {
  handleNextStep: PropTypes.func.isRequired,
  activeNetwork: PropTypes.object.isRequired,
  handleGoogleSyncComplete: PropTypes.func.isRequired,
};
